import {useEffect, useMemo, useRef} from 'react';
import {useDispatch, useStore} from 'react-redux';
import type {ThunkAction, UnknownAction} from '@reduxjs/toolkit';
import type {AppDispatch, RootState} from '../store/store.ts';
import {type StatusRecord, watchStatuses} from '../store/features/Team/statusesLongPoll.ts';

interface UseStatusesLongPollOptions {
    users: readonly (string | number)[];
    update: (statuses: readonly StatusRecord[]) => ThunkAction<unknown, RootState, unknown, UnknownAction>;
    skip?: boolean;
}

export const useStatusesLongPoll = ({users, update, skip = false}: UseStatusesLongPollOptions) => {
    const {getState} = useStore();
    const dispatch = useDispatch<AppDispatch>();
    const latestUpdate = useRef(update);
    latestUpdate.current = update;

    const watchedUsers = useMemo(() => [...new Set(users.map(String))].sort().join(','), [users]);

    useEffect(() => {
        if (skip || !watchedUsers) {
            return undefined;
        }
        return watchStatuses({dispatch, getState}, {
            users: watchedUsers.split(','),
            apply: (statuses) => {
                dispatch(latestUpdate.current(statuses));
            },
        });
    }, [dispatch, getState, watchedUsers, skip]);
};
